import type { FC } from 'react'
import { useState } from 'react'

import AddButton from '@/components/AddButton'

import Sidebar from './Sidebar'

interface Props {
  customerId: string
  subjectId: string
  incomeId: string
}

const AddEmployerReference: FC<Props> = ({ customerId, subjectId, incomeId }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <Sidebar
          customerId={customerId}
          subjectId={subjectId}
          incomeId={incomeId}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <AddButton onClick={() => setIsSidebarOpen(true)} />
    </>
  )
}

export default AddEmployerReference
